/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type OptionalRatingsConfig_formValues = {
    readonly enableOptionalRatings: boolean;
    readonly enableOptionalRatingsSites: ReadonlyArray<string>;
    readonly " $refType": "OptionalRatingsConfig_formValues";
};
export type OptionalRatingsConfig_formValues$data = OptionalRatingsConfig_formValues;
export type OptionalRatingsConfig_formValues$key = {
    readonly " $data"?: OptionalRatingsConfig_formValues$data;
    readonly " $fragmentRefs": FragmentRefs<"OptionalRatingsConfig_formValues">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OptionalRatingsConfig_formValues",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableOptionalRatings",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableOptionalRatingsSites",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any;
(node as any).hash = '31443dade1b418c8441a8978f5d06287';
export default node;
